import { BasicEvent } from "../events/BasicEvent";
export class ArbetsorderNamnUpdatedMessage extends BasicEvent {
    id: number;
    rowVersion: string;
    namn: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderNamnUpdatedMessage";
    constructor() {
        super(ArbetsorderNamnUpdatedMessage.$type);
    }
}
